module.exports = __webpack_public_path__ + "static/media/roulette_chip_place.8ef1b520.mp3";